import React from 'react';
import classNames from 'classnames';
import { useDrag } from 'react-dnd';
import tinycolor from 'tinycolor2';

// import Address from '../../shared/Address';
// import Currency from '../../shared/Currency';
import styles from './AvailableEmployees.css';
import { bool } from 'prop-types';

export const DraggableType = 'crew';


const makeStyle = ({ color }) => !color ? null : {
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',
};
const employeeList = ({color}) => !color ? {
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',

} :{
  border: '1px solid #ccc', 
  padding: '2px 8px', 
  borderRadius: '5px', 
  fontWeight:'bold',
  backgroundColor: color,
};

const StandardCrew = ({ standardcrew,color }) => {

  const [, drag] = useDrag({
    item: { id: standardcrew.id, standardcrew, type: DraggableType },
  });
  return (
    <div
      ref={drag}      
    >
     
      <div className={styles.employeeList}  style={{margin: '10px 0',
        backgroundColor: color ? '#304e1e' : '', color: color ? '#fff' : '',
      }}>{standardcrew.equipment? standardcrew.equipment.name:'' } 
      
      <div>
      {
          standardcrew.resources.map((r) =>
          {
             return (
              <div key={r.resource.id}>{r.resource.firstName}   {r.resource.lastName} </div>
             ) 
          }
          )
      }
      </div>
      </div>
      
     
    </div>
  );
};
export default StandardCrew;
